export function getElementIndex(element) {
	return Array.from(element.parentNode.children).indexOf(element);
}

export function getSiblings(elem) {
	return Array.prototype.filter.call(elem.parentNode.children, function(sibling) {
		return sibling !== elem;
	});
}

export function loadJs(src) {
	return new Promise(function(resolve, reject) {
		const script = document.createElement('script')
		script.type = 'text/javascript';
		script.onload = resolve;
		script.onerror = reject;
		script.src = src;
		document.head.append(script);
	});
}